var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "faq-loader" } }, [
    _c("div", { attrs: { id: "questions-loader" } }, [
      _c(
        "div",
        { staticClass: "px-xl-5 px-3" },
        [
          _c(
            "b-row",
            { staticClass: "mb-3" },
            [_c("b-skeleton", { attrs: { type: "input", width: "100%" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c("b-skeleton-img", {
                attrs: { "no-aspect": "", height: "150px" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }